import { render, staticRenderFns } from "./noLicencelWarnList.vue?vue&type=template&id=6b9002a8"
import script from "./noLicencelWarnList.vue?vue&type=script&lang=js"
export * from "./noLicencelWarnList.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports